module.exports = __webpack_public_path__ + "static/media/20240530080149_IMG_7423-min.a354e319.JPG";